import { Home } from 'src/app/shared/models/home.model';
import { SubmissionValue } from './submission-value.model';

export class Submission {
  Id?: number;
  FormStructureId?: string;
  HomeId?: number;
  SubmissionValues?: SubmissionValue[];
  SubmittedOn?: Date;
  ModifiedOn?: Date;

  Home?: Home;

  private static readonly NEEMPlants = ['955', '972'] as const;

  public static IsNEEMPlant(plantNumber: string | null | undefined): boolean {
    return this.NEEMPlants.some((id) => plantNumber === id);
  }

  public static DetermineFormStructureId(
    version: string,
    plantNumber: string,
  ): string {
    const isVersionTwo = version === '2';
    const isNeemPlant = this.IsNEEMPlant(plantNumber);

    const formTypeMap = {
      'true,true': SubmissionFormType.VersionTwoNEEM.toString(),
      'true,false': SubmissionFormType.VersionThreeNEEM.toString(),
      'false,true': SubmissionFormType.VersionTwo.toString(),
      'false,false': SubmissionFormType.VersionThree.toString(),
    };

    return formTypeMap[`${isNeemPlant},${isVersionTwo}`];
  }
}

export enum SubmissionFormType {
  VersionTwo = 2,
  VersionTwoNEEM = 4,
  VersionThree = 1,
  VersionThreeNEEM = 3,
}

export enum SubmissionVersion {
  VersionNotSelected = 0,
  VersionTwo = 2,
  VersionThree = 3,
}

export enum SubmissionStatus {
  NeedsAttention = 1,
  ReadyToSubmit = 2,
  Submitted = 3,
  Credited = 4,
  Error = 5,
  NotEligible = 6,
  InProgress = 7,
  SubmittedManually = 8,
}

export function statusToString(status: SubmissionStatus): string {
  switch (status) {
    case SubmissionStatus.NeedsAttention:
      return 'Needs Attention';
    case SubmissionStatus.ReadyToSubmit:
      return 'Ready To Submit';
    case SubmissionStatus.Submitted:
      return 'Submitted';
    case SubmissionStatus.Credited:
      return 'Credited';
    case SubmissionStatus.Error:
      return 'Error';
    case SubmissionStatus.NotEligible:
      return 'Not Eligible';
    case SubmissionStatus.InProgress:
      return 'In Progress';
    case SubmissionStatus.SubmittedManually:
      return 'Submitted Manually';
  }
}
